
import { Component, Vue } from 'vue-property-decorator';

import Form15ProcessHeader from "@/components/process/Form15/components/Form15ProcessHeader.vue";
import Form15CaseInformation from "@/components/process/Form15/components/Form15CaseInformation.vue";
import { form15StatusInfoType } from '@/types/Information/Form15';

@Component({
    components:{
        Form15ProcessHeader,
        Form15CaseInformation
    }
})
export default class StartForm15 extends Vue {

    stepsCompleted = {} as form15StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
